// Значення взяті з src/scss/_variables.scss і актуального _Dashboard.scss
// (newDesign), щоб прототип збігався з реальною таблицею дашборду —
// там зараз Gilroy, а не Inter, для назв/кнопок/бейджів.
export const brand = {
    navy: '#010035',
    navyHover: '#060553',
    grey: '#7C7C7C',
    bg: '#E7E5E5'
}

export const headingFont = "'Gilroy-SemiBold', sans-serif"
export const fontFamily = "'Gilroy-Medium', sans-serif"

export const headingSx = { fontFamily: headingFont, color: brand.navy, fontWeight: 500, margin: 0 }
export const subtextSx = { fontFamily, color: brand.grey, fontSize: 13 }

export const btnPrimarySx = {
    fontFamily,
    borderRadius: '20px',
    px: 3,
    bgcolor: brand.navy,
    color: '#fff',
    boxShadow: 'none',
    '&:hover': { bgcolor: brand.navyHover, boxShadow: 'none' },
    '&.Mui-disabled': { bgcolor: 'rgba(1,0,53,0.3)', color: '#fff' }
}

export const btnSecondarySx = {
    fontFamily,
    borderRadius: '20px',
    px: 3,
    borderColor: brand.navy,
    color: brand.navy,
    '&:hover': { borderColor: brand.navy, bgcolor: 'rgba(1,0,53,0.06)' }
}
